import { ClientType } from "../../connection/models/Connector";



export enum WarehouseConnectionType {
    BOL = ClientType.BOL,
    MONTA = ClientType.MONTA,
    WOOCOMMERCE = ClientType.WOOCOMMERCE,
    FILE = 'file',
    MANUAL = 'manual',
    REQUEST_CONNECTOR = 'request-connector',
    IMPORT4YOU = ClientType.IMPORT4YOU,
    PRODUCT_FLOW = ClientType.PRODUCT_FLOW,
    SHOPIFY = ClientType.SHOPIFY,
    AMAZON = ClientType.AMAZON,
    CHANNELDOCK = ClientType.CHANNELDOCK,
}